'use client'

import { useTranslations } from 'next-intl'
import { Button } from '@/components/button'
import { cn } from '@/utils/styles/cn'

interface IExternalContentPlaceholderProps {
    onActivate: () => void
    className?: string
}

export const ExternalContentPlaceholder = ({
    onActivate,
    className,
}: IExternalContentPlaceholderProps) => {
    const t = useTranslations()

    return (
        <div
            className={cn(
                'flex flex-col items-center gap-3 rounded-2xl border border-gray-200 bg-gray-50 px-6 py-10 text-center',
                className
            )}
        >
            <p className="text-lg font-bold">{t('consent.content.title')}</p>

            <p className="max-w-md text-sm text-gray-600">{t('consent.content.description')}</p>

            <Button styleType="primary" shape="pill" onClick={onActivate}>
                {t('consent.content.button')}
            </Button>
        </div>
    )
}
